export const GET_STORE_IMAGES = 'GET_STORE_IMAGES';

export const actionGetStoreImages = (payload: any) => ({
  type: GET_STORE_IMAGES,
  payload,
});
